// src/onus_components/Tr069Modal.jsx — enganchar la ONT al servidor TR-069
//
// Le asigna el perfil del ACS. El número de perfil lo decide el backend
// (OLT_TR069_PROFILE_ID); aquí no se elige.

import React, { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";
import { Iconos } from "../componentes/base";
import ModalPasos, { fichaOnu, leerRespuesta, ubicacionDe } from "../componentes/olt/ModalPasos";

export default function Tr069Modal({ open, onu, onClose, onSuccess }) {
  const [estado, setEstado] = useState("reposo");
  const [salida, setSalida] = useState([]);
  const [error, setError] = useState("");

  const u = ubicacionDe(onu);

  useEffect(() => {
    if (!open) return;
    setEstado("reposo"); setSalida([]); setError("");
  }, [open, onu?.id]);

  async function ejecutar() {
    if (!onu?.id) return;
    setEstado("corriendo"); setSalida([]); setError("");
    try {
      const res = await authFetch(`/api/onus/${onu.id}/tr069_apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      const data = await leerRespuesta(res);
      setSalida(Array.isArray(data?.outputs) ? data.outputs : []);
      if (!res.ok || !data?.ok) throw new Error(data?.mensaje || "No se pudo activar TR-069.");
      onSuccess?.(data?.mensaje || "TR-069 activado");
    } catch (e) {
      setError(String(e?.message || e));
    } finally {
      setEstado("fin");
    }
  }

  return (
    <ModalPasos
      abierto={open}
      titulo="Enganchar a TR-069"
      icono={Iconos.ajustes}
      ficha={fichaOnu(onu)}
      aviso="Le asigna a la ONT el perfil del servidor TR-069. A partir de ahí GenieACS puede leerla y configurarla. No corta el servicio."
      verbo="Activar TR-069"
      estado={estado}
      salida={salida}
      error={error}
      mensaje="Perfil TR-069 asignado. La ONT aparecerá en GenieACS en unos minutos."
      fases={[
        { rotulo: "Entrar al puerto", coincide: /^(enable|config|interface gpon)/, cmds: [`interface gpon ${u.frameSlot}`] },
        { rotulo: "Asignar el perfil del ACS", coincide: /^ont tr069-server-config/, cmds: [`ont tr069-server-config ${u.pon} ${u.ont} profile-id (el del servidor)`] },
        { rotulo: "Salir", coincide: /^(quit|return)$/, cmds: ["quit"] },
      ]}
      onEjecutar={ejecutar}
      onCerrar={onClose}
    />
  );
}
